/* eslint-disable no-console */
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';

import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
// eslint-disable-next-line no-unused-vars
import PlotlyGraph from 'components/utility-component/custom-plotly/PlotlyGraph';
import CustomizedDataGrid from 'components/wrapped-component/customized-data-grid/CustomizedDataGrid';
import WaferMap from '../wafer-map/WaferMap';
import DataGrid from '../data-grid-component/DataGridComponent';
// eslint-disable-next-line no-unused-vars
import WebGLUtils from '../wafer-map/web-gl-utils/Utils';
// eslint-disable-next-line no-unused-vars
import WaferData from '../WaferData';
import PublishSubscribe, { EventTypes } from '../PublishSubscribe';
// eslint-disable-next-line no-unused-vars
import { DieSubView, WaferMapData, WaferMapTestData } from '../wafer-map/web-gl-utils/Types';
import { RandomNumberUtility } from '../wafer-map/web-gl-utils/RandomNumberUtility';

type WaferMapGridViewProps = {
  keyIndex: number | string,
  waferData: WaferMapTestData,
  dieSubView: DieSubView;
  dieSize: { dieWidth: number, dieHeight: number },
};

type WaferMapGridViewState = {
  waferMapInstances: { [key: string]: WebGLUtils },
  gridInstances: { [key: string]: DataGrid },
  plotlyInstances: { [key: string]: PlotlyGraph },
  customizedDataGridInstances: { [key: string]: CustomizedDataGrid },
  dat: any,
  tabDat: any;
  wafDat: WaferData;
};

class WaferMapGridView extends React.Component<WaferMapGridViewProps, WaferMapGridViewState> {
  constructor(props: WaferMapGridViewProps) {
    super(props);
    const obj = new RandomNumberUtility().randomWaferDataWithBinNum(
      150,
      250,
      5,
      5 / 2,
      [1, 2, 3, 4, 5, 6, 7, 8, 9],
    );
    this.state = {
      waferMapInstances: {},
      gridInstances: {},
      plotlyInstances: {},
      customizedDataGridInstances: {},
      dat: [],
      tabDat: [],
      wafDat: new WaferData(obj.data, obj.dieSubView),
    };
  }

  appendKeyIndex = (key: string | number) => {
    const { keyIndex } = this.props;
    return keyIndex + key.toString();
  };

  setWaferInstanceHandler = (utils: WebGLUtils, keyIndex: string) => {
    const { waferMapInstances } = this.state;
    waferMapInstances[keyIndex] = utils;
  };

  setGridInstanceHandler = (grid: DataGrid, keyIndex: string) => {
    const { gridInstances } = this.state;
    gridInstances[keyIndex] = grid;
  };

  setPlotInstanceHandler = (plot: PlotlyGraph, keyIndex: string) => {
    const { plotlyInstances } = this.state;
    plotlyInstances[keyIndex] = plot;
  };

  setCustomGridInstanceHandler = (customizedDataGrid: CustomizedDataGrid, keyIndex: string) => {
    const { customizedDataGridInstances } = this.state;
    customizedDataGridInstances[keyIndex] = customizedDataGrid;
  };

  componentDidMount() {
    this.setSubsribers();
  }

  componentDidUpdate() {
    this.setSubsribers();
  }

  setSubsribers = () => {
    const {
      waferMapInstances, customizedDataGridInstances, plotlyInstances,
    } = this.state;
    const ps = PublishSubscribe();
    // wafermaps subscribe to drag from radarpointer events
    ps.subscribeToWaferID(
      EventTypes.UPDATE_WAFER_ON_RADARPOINTER_UPDATE,
      waferMapInstances[this.appendKeyIndex('wf0')]?.updateAnchorOnRadarDragOrClick,
      this.appendKeyIndex('wf0'),
      this.appendKeyIndex('wf0'),
    );
    ps.subscribeToWaferID(
      EventTypes.UPDATE_RADARPOINTER_ON_RADARPOINTER_UPDATE,
      waferMapInstances[this.appendKeyIndex('wf0')]?.updateRadarPointer,
      this.appendKeyIndex('wf0'),
      this.appendKeyIndex('wf0'),
    );
    // id 0 subsribes to id 1
    ps.subscribeToWaferID(
      EventTypes.UPDATE_WAFER_ON_RADARPOINTER_UPDATE,
      waferMapInstances[this.appendKeyIndex('wf0')]?.updateAnchorOnRadarDragOrClick,
      this.appendKeyIndex('wf1'),
      this.appendKeyIndex('wf0'),
    );
    ps.subscribeToWaferID(
      EventTypes.UPDATE_RADARPOINTER_ON_RADARPOINTER_UPDATE,
      waferMapInstances[this.appendKeyIndex('wf0')]?.updateRadarPointer,
      this.appendKeyIndex('wf1'),
      this.appendKeyIndex('wf0'),
    );
    ps.subscribeToWaferID(
      EventTypes.UPDATE_WAFER_ON_RADARPOINTER_UPDATE,
      waferMapInstances[this.appendKeyIndex('wf1')]?.updateAnchorOnRadarDragOrClick,
      this.appendKeyIndex('wf0'),
      this.appendKeyIndex('wf1'),
    );
    ps.subscribeToWaferID(
      EventTypes.UPDATE_RADARPOINTER_ON_RADARPOINTER_UPDATE,
      waferMapInstances[this.appendKeyIndex('wf1')]?.updateRadarPointer,
      this.appendKeyIndex('wf0'),
      this.appendKeyIndex('wf1'),
    );
    ps.subscribeToWaferID(
      EventTypes.UPDATE_WAFER_ON_RADARPOINTER_UPDATE,
      waferMapInstances[this.appendKeyIndex('wf1')]?.updateAnchorOnRadarDragOrClick,
      this.appendKeyIndex('wf1'),
      this.appendKeyIndex('wf1'),
    );
    ps.subscribeToWaferID(
      EventTypes.UPDATE_RADARPOINTER_ON_RADARPOINTER_UPDATE,
      waferMapInstances[this.appendKeyIndex('wf1')]?.updateRadarPointer,
      this.appendKeyIndex('wf1'),
      this.appendKeyIndex('wf1'),
    );

    ps.subscribeToWaferID(
      EventTypes.WAFER_MAP_DRAGGED,
      waferMapInstances[this.appendKeyIndex('wf0')]?.dragWaferMap,
      this.appendKeyIndex('wf1'),
      this.appendKeyIndex('wf0'),
    );
    ps.subscribeToWaferID(
      EventTypes.WAFER_MAP_DRAG_STARTED,
      waferMapInstances[this.appendKeyIndex('wf0')]?.setPreDragAnchor,
      this.appendKeyIndex('wf1'),
      this.appendKeyIndex('wf0'),
    );
    ps.subscribeToWaferID(
      EventTypes.WAFER_MAP_ZOOMED,
      waferMapInstances[this.appendKeyIndex('wf0')]?.zoomWaferMap,
      this.appendKeyIndex('wf1'),
      this.appendKeyIndex('wf0'),
    );
    ps.subscribeToWaferID(
      EventTypes.WAFER_MAP_ZOOMED_USING_BUTTONS,
      waferMapInstances[this.appendKeyIndex('wf0')]?.zoomWaferMapUsingButtons,
      this.appendKeyIndex('wf1'),
      this.appendKeyIndex('wf0'),
    );
    ps.subscribeToWaferID(
      EventTypes.WAFER_RESET,
      waferMapInstances[this.appendKeyIndex('wf0')]?.resetWaferZoom,
      this.appendKeyIndex('wf1'),
      this.appendKeyIndex('wf0'),
    );

    // wafermap subscribe to selection on wafermap
    ps.subscribeToWaferID(
      EventTypes.DIE_SELECTED_ON_WAFER,
      waferMapInstances[this.appendKeyIndex('wf0')]?.dieSelectedOnWafer,
      this.appendKeyIndex('wf1'),
      this.appendKeyIndex('wf0'),
    );
    ps.subscribeToWaferID(
      EventTypes.DIE_SELECTED_ON_WAFER,
      waferMapInstances[this.appendKeyIndex('wf1')]?.dieSelectedOnWafer,
      this.appendKeyIndex('wf0'),
      this.appendKeyIndex('wf1'),
    );

    // wafermap subscribe to selection on custom grid
    ps.subscribeToCustomGridID(
      EventTypes.DATA_FILTER_CLEARED_ON_CUSTOMIZED_GRID,
      waferMapInstances[this.appendKeyIndex('wf1')]?.clearFilterData,
      this.appendKeyIndex('cg0'),
      this.appendKeyIndex('wf1'),
      'dieNumber',
      'dieNumber',
    );
    ps.subscribeToCustomGridID(
      EventTypes.DATA_FILTER_APPLIED_ON_CUSTOMIZED_GRID,
      waferMapInstances[this.appendKeyIndex('wf1')]?.setFilterDataFromCustomGrid,
      this.appendKeyIndex('cg0'),
      this.appendKeyIndex('wf1'),
      'dieNumber',
      'dieNumber',
    );
    ps.subscribeToCustomGridID(
      EventTypes.SELECTION_ON_CUSTOMIZED_GRID,
      waferMapInstances[this.appendKeyIndex('wf1')]?.dataSelectedOnCustomGrid,
      this.appendKeyIndex('cg0'),
      this.appendKeyIndex('wf1'),
      'dieNumber',
      'dieNumber',
    );

    // custom grid subscribe to selection on custom grid
    ps.subscribeToCustomGridID(
      EventTypes.DATA_FILTER_CLEARED_ON_CUSTOMIZED_GRID,
      customizedDataGridInstances[this.appendKeyIndex('cg1')]?.clearFilterData,
      this.appendKeyIndex('cg0'),
      this.appendKeyIndex('cg1'),
      'dieNumber',
      'dieNumber',
    );
    ps.subscribeToCustomGridID(
      EventTypes.DATA_FILTER_APPLIED_ON_CUSTOMIZED_GRID,
      customizedDataGridInstances[this.appendKeyIndex('cg1')]?.setFilterDataFromCustomGrid,
      this.appendKeyIndex('cg0'),
      this.appendKeyIndex('cg1'),
      'dieNumber',
      'dieNumber',
    );
    ps.subscribeToCustomGridID(
      EventTypes.SELECTION_ON_CUSTOMIZED_GRID,
      customizedDataGridInstances[this.appendKeyIndex('cg1')]?.dataSelected,
      this.appendKeyIndex('cg0'),
      this.appendKeyIndex('cg1'),
      'dieNumber',
      'dieNumber',
    );

    // plotly plots subscribe to selection on custom grid
    ps.subscribeToCustomGridID(
      EventTypes.DATA_FILTER_CLEARED_ON_CUSTOMIZED_GRID,
      plotlyInstances[this.appendKeyIndex('plot0')]?.clearFilterData,
      this.appendKeyIndex('cg0'),
      this.appendKeyIndex('plot0'),
      'dieNumber',
      'dieNumber',
    );
    ps.subscribeToCustomGridID(
      EventTypes.DATA_FILTER_APPLIED_ON_CUSTOMIZED_GRID,
      plotlyInstances[this.appendKeyIndex('plot0')]?.setFilterDataFromCustomGrid,
      this.appendKeyIndex('cg0'),
      this.appendKeyIndex('plot0'),
      'dieNumber',
      'dieNumber',
    );
    ps.subscribeToCustomGridID(
      EventTypes.SELECTION_ON_CUSTOMIZED_GRID,
      plotlyInstances[this.appendKeyIndex('plot0')]?.dataSelectedOnCustomGrid,
      this.appendKeyIndex('cg0'),
      this.appendKeyIndex('plot0'),
      'dieNumber',
      'dieNumber',
    );

    // other components subscribe to selection on wafermap
    ps.subscribeToWaferID(
      EventTypes.DATA_SELECTED_ON_WAFER,
      customizedDataGridInstances[this.appendKeyIndex('cg0')]?.dataSelected,
      this.appendKeyIndex('wf1'),
      this.appendKeyIndex('cg0'),
      'dieNumber',
      'dieNumber',
    );

    ps.subscribeToWaferID(
      EventTypes.DATA_SELECTED_ON_WAFER,
      plotlyInstances[this.appendKeyIndex('plot0')]?.dataSelectedOnWafer,
      this.appendKeyIndex('wf1'),
      this.appendKeyIndex('plot0'),
      'dieNumber',
      'dieNumber',
    );

    // other components subscribe to selection on plotly plot
    ps.subscribeToPlotID(
      EventTypes.DATA_SELECTED_ON_PLOT,
      customizedDataGridInstances[this.appendKeyIndex('cg0')]?.dataSelected,
      this.appendKeyIndex('plot0'),
      this.appendKeyIndex('cg0'),
      'dieNumber',
      'dieNumber',
    );
    ps.subscribeToPlotID(
      EventTypes.DATA_UNSELECTED_ON_PLOT,
      customizedDataGridInstances[this.appendKeyIndex('cg0')]?.dataUnSelected,
      this.appendKeyIndex('plot0'),
      this.appendKeyIndex('cg0'),
      'dieNumber',
      'dieNumber',
    );
    ps.subscribeToPlotID(
      EventTypes.DATA_SELECTED_ON_PLOT,
      plotlyInstances[this.appendKeyIndex('plot1')]?.dataSelectedOnPlot,
      this.appendKeyIndex('plot0'),
      this.appendKeyIndex('plot1'),
      'dieNumber',
      'dieNumber',
    );
    ps.subscribeToPlotID(
      EventTypes.DATA_UNSELECTED_ON_PLOT,
      plotlyInstances[this.appendKeyIndex('plot1')]?.dataUnSelectedOnPlot,
      this.appendKeyIndex('plot0'),
      this.appendKeyIndex('plot1'),
      'dieNumber',
      'dieNumber',
    );
    ps.subscribeToPlotID(
      EventTypes.DATA_SELECTED_ON_PLOT,
      waferMapInstances[this.appendKeyIndex('wf1')]?.dataSelectedOnPlot,
      this.appendKeyIndex('plot0'),
      this.appendKeyIndex('wf1'),
      'dieNumber',
      'dieNumber',
    );
    ps.subscribeToPlotID(
      EventTypes.DATA_UNSELECTED_ON_PLOT,
      waferMapInstances[this.appendKeyIndex('wf1')]?.dataUnSelectedOnPlot,
      this.appendKeyIndex('plot0'),
      this.appendKeyIndex('wf1'),
      'dieNumber',
      'dieNumber',
    );

    // eslint-disable-next-line max-len
    ps.subscribeToPlotID(
      EventTypes.DATA_SELECTED_ON_PLOT,
      customizedDataGridInstances[this.appendKeyIndex('cg5')]?.dataSelected,
      this.appendKeyIndex('plot5'),
      this.appendKeyIndex('cg5'),
      ['groupName', 'bin'],
      ['groupName', 'bin'],
    );
    ps.subscribeToPlotID(
      EventTypes.DATA_UNSELECTED_ON_PLOT,
      customizedDataGridInstances[this.appendKeyIndex('cg5')]?.dataUnSelected,
      this.appendKeyIndex('plot5'),
      this.appendKeyIndex('cg5'),
      ['groupName', 'bin'],
      ['groupName', 'bin'],
    );
    ps.subscribeToPlotID(
      EventTypes.DATA_HIDDEN_ON_PLOT,
      customizedDataGridInstances[this.appendKeyIndex('cg5')]?.dataHidden,
      this.appendKeyIndex('plot5'),
      this.appendKeyIndex('cg5'),
      ['groupName', 'bin'],
      ['groupName', 'bin'],
    );
    ps.subscribeToPlotID(
      EventTypes.DATA_DELETED_ON_PLOT,
      customizedDataGridInstances[this.appendKeyIndex('cg5')]?.dataDeleted,
      this.appendKeyIndex('plot5'),
      this.appendKeyIndex('cg5'),
      ['groupName', 'bin'],
      ['groupName', 'bin'],
    );
    ps.subscribeToPlotID(
      EventTypes.DATA_UNHIDDEN_ON_PLOT,
      customizedDataGridInstances[this.appendKeyIndex('cg5')]?.dataUnHidden,
      this.appendKeyIndex('plot5'),
      this.appendKeyIndex('cg5'),
      ['groupName', 'bin'],
      ['groupName', 'bin'],
    );
    ps.subscribeToPlotID(
      EventTypes.DATA_UNHIDDEN_ON_PLOT,
      customizedDataGridInstances[this.appendKeyIndex('cg0')]?.dataUnHidden,
      this.appendKeyIndex('plot0'),
      this.appendKeyIndex('cg0'),
      'dieNumber',
      'dieNumber',
    );
    ps.subscribeToPlotID(
      EventTypes.DATA_HIDDEN_ON_PLOT,
      customizedDataGridInstances[this.appendKeyIndex('cg0')]?.dataHidden,
      this.appendKeyIndex('plot0'),
      this.appendKeyIndex('cg0'),
      'dieNumber',
      'dieNumber',
    );
    ps.subscribeToPlotID(
      EventTypes.DATA_DELETED_ON_PLOT,
      customizedDataGridInstances[this.appendKeyIndex('cg0')]?.dataDeleted,
      this.appendKeyIndex('plot0'),
      this.appendKeyIndex('cg0'),
      'dieNumber',
      'dieNumber',
    );
    ps.subscribeToCustomGridID(
      EventTypes.DATA_FILTER_CLEARED_ON_CUSTOMIZED_GRID,
      plotlyInstances[this.appendKeyIndex('plot5')]?.clearFilterData,
      this.appendKeyIndex('cg5'),
      this.appendKeyIndex('plot5'),
      ['groupName', 'bin'],
      ['groupName', 'bin'],
    );
    ps.subscribeToCustomGridID(
      EventTypes.DATA_FILTER_APPLIED_ON_CUSTOMIZED_GRID,
      plotlyInstances[this.appendKeyIndex('plot5')]?.setFilterDataFromCustomGrid,
      this.appendKeyIndex('cg5'),
      this.appendKeyIndex('plot5'),
      ['groupName', 'bin'],
      ['groupName', 'bin'],
    );
    ps.subscribeToCustomGridID(
      EventTypes.SELECTION_ON_CUSTOMIZED_GRID,
      plotlyInstances[this.appendKeyIndex('plot5')]?.dataSelectedOnCustomGrid,
      this.appendKeyIndex('cg5'),
      this.appendKeyIndex('plot5'),
      ['groupName', 'bin'],
      ['groupName', 'bin'],
    );
    ps.subscribeToCustomGridID(
      EventTypes.DELETION_ON_CUSTOMIZED_GRID,
      plotlyInstances[this.appendKeyIndex('plot5')]?.dataDeletedOnCustomGrid,
      this.appendKeyIndex('cg5'),
      this.appendKeyIndex('plot5'),
      ['groupName', 'bin'],
      ['groupName', 'bin'],
    );
    ps.subscribeToCustomGridID(
      EventTypes.HIDE_ON_CUSTOMIZED_GRID,
      plotlyInstances[this.appendKeyIndex('plot5')]?.dataHiddenOnCustomGrid,
      this.appendKeyIndex('cg5'),
      this.appendKeyIndex('plot5'),
      ['groupName', 'bin'],
      ['groupName', 'bin'],
    );
    ps.subscribeToCustomGridID(
      EventTypes.FILTER_EXPRESSION,
      (data: { filterExp: any }) => {
        // console.log(data);
      },
      this.appendKeyIndex('cg5'),
      'randID',
      ['groupName', 'bin'],
      ['groupName', 'bin'],
    );
    ps.subscribeToCustomGridID(
      EventTypes.UNHIDE_ON_CUSTOMIZED_GRID,
      plotlyInstances[this.appendKeyIndex('plot5')]?.dataUnHiddenOnCustomGrid,
      this.appendKeyIndex('cg5'),
      this.appendKeyIndex('plot5'),
      ['groupName', 'bin'],
      ['groupName', 'bin'],
    );
    ps.subscribeToCustomGridID(
      EventTypes.HIDE_ON_CUSTOMIZED_GRID,
      plotlyInstances[this.appendKeyIndex('plot0')]?.dataHiddenOnCustomGrid,
      this.appendKeyIndex('cg0'),
      this.appendKeyIndex('plot0'),
      'dieNumber',
      'dieNumber',
    );
    ps.subscribeToCustomGridID(
      EventTypes.UNHIDE_ON_CUSTOMIZED_GRID,
      plotlyInstances[this.appendKeyIndex('plot0')]?.dataUnHiddenOnCustomGrid,
      this.appendKeyIndex('cg0'),
      this.appendKeyIndex('plot0'),
      'dieNumber',
      'dieNumber',
    );
  };

  renderHandler = () => {
    const gdata: any = [];
    // eslint-disable-next-line max-len
    const groupData = JSON.parse('{"L71227_W001":[{"groupName":"L71227_W001","bin":"0","passFailFlag":"P","binCount":3069},{"groupName":"L71227_W001","bin":"1","passFailFlag":"F","binCount":7},{"groupName":"L71227_W001","bin":"3","passFailFlag":"P","binCount":19947},{"groupName":"L71227_W001","bin":"2","passFailFlag":"F","binCount":33},{"groupName":"L71227_W001","bin":"4","passFailFlag":"F","binCount":1408},{"groupName":"L71227_W001","bin":"5","passFailFlag":"F","binCount":2},{"groupName":"L71227_W001","bin":"7","passFailFlag":"F","binCount":2},{"groupName":"L71227_W001","bin":"8","passFailFlag":"F","binCount":1},{"groupName":"L71227_W001","bin":"15","passFailFlag":"F","binCount":1},{"groupName":"L71227_W001","bin":"22","passFailFlag":"F","binCount":9},{"groupName":"L71227_W001","bin":"40","passFailFlag":"F","binCount":1}],"L71227_W002":[{"groupName":"L71227_W002","bin":"0","passFailFlag":"P","binCount":3061},{"groupName":"L71227_W002","bin":"1","passFailFlag":"F","binCount":12},{"groupName":"L71227_W002","bin":"3","passFailFlag":"P","binCount":13456},{"groupName":"L71227_W002","bin":"2","passFailFlag":"F","binCount":30},{"groupName":"L71227_W002","bin":"4","passFailFlag":"F","binCount":15},{"groupName":"L71227_W002","bin":"5","passFailFlag":"F","binCount":5},{"groupName":"L71227_W002","bin":"6","passFailFlag":"F","binCount":2},{"groupName":"L71227_W002","bin":"7","passFailFlag":"F","binCount":1},{"groupName":"L71227_W002","bin":"8","passFailFlag":"F","binCount":1},{"groupName":"L71227_W002","bin":"9","passFailFlag":"F","binCount":56},{"groupName":"L71227_W002","bin":"10","passFailFlag":"F","binCount":90},{"groupName":"L71227_W002","bin":"15","passFailFlag":"F","binCount":1},{"groupName":"L71227_W002","bin":"22","passFailFlag":"F","binCount":9},{"groupName":"L71227_W002","bin":"24","passFailFlag":"F","binCount":1},{"groupName":"L71227_W002","bin":"28","passFailFlag":"F","binCount":1}],"L71227_W004":[{"groupName":"L71227_W004","bin":"0","passFailFlag":"P","binCount":2525},{"groupName":"L71227_W004","bin":"1","passFailFlag":"F","binCount":7},{"groupName":"L71227_W004","bin":"3","passFailFlag":"P","binCount":1794},{"groupName":"L71227_W004","bin":"2","passFailFlag":"F","binCount":31},{"groupName":"L71227_W004","bin":"4","passFailFlag":"F","binCount":18},{"groupName":"L71227_W004","bin":"5","passFailFlag":"F","binCount":75},{"groupName":"L71227_W004","bin":"6","passFailFlag":"F","binCount":1},{"groupName":"L71227_W004","bin":"7","passFailFlag":"F","binCount":1},{"groupName":"L71227_W004","bin":"22","passFailFlag":"F","binCount":3},{"groupName":"L71227_W004","bin":"27","passFailFlag":"F","binCount":1},{"groupName":"L71227_W004","bin":"30","passFailFlag":"F","binCount":1},{"groupName":"L71227_W004","bin":"35","passFailFlag":"F","binCount":1},{"groupName":"L71227_W004","bin":"40","passFailFlag":"F","binCount":5}]}');
    // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for (const item in groupData) {
      const groupString:any = [];
      const binString:any = [];
      const valueString:any = [];
      const values = groupData[item];
      values.forEach((bindata:any) => {
        groupString.push(item);
        binString.push(bindata.bin);
        valueString.push(bindata.binCount);
      });
      const x:any = [];
      x.push(groupString);
      x.push(binString);
      gdata.push({ x, y: valueString });
    }
    const randnum = Math.ceil((Math.random() * 40) + 5);
    const obj = new RandomNumberUtility().randomWaferDataWithBinNum(
      150,
      250,
      randnum,
      randnum / 2,
      [1, 2, 3, 4, 5, 6, 7, 8, 9],
    );
    this.setState({
      wafDat: new WaferData(obj.data, obj.dieSubView),
      dat: gdata,
      tabDat: [{
        groupName: 'L71227_W001', bin: '0', passFailFlag: 'P', binCount: 3069,
      }, {
        groupName: 'L71227_W001', bin: '1', passFailFlag: 'F', binCount: 7,
      }, {
        groupName: 'L71227_W001', bin: '3', passFailFlag: 'P', binCount: 19947,
      }, {
        groupName: 'L71227_W001', bin: '2', passFailFlag: 'F', binCount: 33,
      }, {
        groupName: 'L71227_W001', bin: '4', passFailFlag: 'F', binCount: 1408,
      }, {
        groupName: 'L71227_W001', bin: '5', passFailFlag: 'F', binCount: 2,
      }, {
        groupName: 'L71227_W001', bin: '7', passFailFlag: 'F', binCount: 2,
      }, {
        groupName: 'L71227_W001', bin: '8', passFailFlag: 'F', binCount: 1,
      }, {
        groupName: 'L71227_W001', bin: '15', passFailFlag: 'F', binCount: 1,
      }, {
        groupName: 'L71227_W001', bin: '22', passFailFlag: 'F', binCount: 9,
      }, {
        groupName: 'L71227_W001', bin: '40', passFailFlag: 'F', binCount: 1,
      }, {
        groupName: 'L71227_W002', bin: '0', passFailFlag: 'P', binCount: 3061,
      }, {
        groupName: 'L71227_W002', bin: '1', passFailFlag: 'F', binCount: 12,
      }, {
        groupName: 'L71227_W002', bin: '3', passFailFlag: 'P', binCount: 13456,
      }, {
        groupName: 'L71227_W002', bin: '2', passFailFlag: 'F', binCount: 30,
      }, {
        groupName: 'L71227_W002', bin: '4', passFailFlag: 'F', binCount: 15,
      }, {
        groupName: 'L71227_W002', bin: '5', passFailFlag: 'F', binCount: 5,
      }, {
        groupName: 'L71227_W002', bin: '6', passFailFlag: 'F', binCount: 2,
      }, {
        groupName: 'L71227_W002', bin: '7', passFailFlag: 'F', binCount: 1,
      }, {
        groupName: 'L71227_W002', bin: '8', passFailFlag: 'F', binCount: 1,
      }, {
        groupName: 'L71227_W002', bin: '9', passFailFlag: 'F', binCount: 56,
      }, {
        groupName: 'L71227_W002', bin: '10', passFailFlag: 'F', binCount: 90,
      }, {
        groupName: 'L71227_W002', bin: '15', passFailFlag: 'F', binCount: 1,
      }, {
        groupName: 'L71227_W002', bin: '22', passFailFlag: 'F', binCount: 9,
      }, {
        groupName: 'L71227_W002', bin: '24', passFailFlag: 'F', binCount: 1,
      }, {
        groupName: 'L71227_W002', bin: '28', passFailFlag: 'F', binCount: 1,
      }, {
        groupName: 'L71227_W004', bin: '0', passFailFlag: 'P', binCount: 2525,
      }, {
        groupName: 'L71227_W004', bin: '1', passFailFlag: 'F', binCount: 7,
      }, {
        groupName: 'L71227_W004', bin: '3', passFailFlag: 'P', binCount: 1794,
      }, {
        groupName: 'L71227_W004', bin: '2', passFailFlag: 'F', binCount: 31,
      }, {
        groupName: 'L71227_W004', bin: '4', passFailFlag: 'F', binCount: 18,
      }, {
        groupName: 'L71227_W004', bin: '5', passFailFlag: 'F', binCount: 75,
      }, {
        groupName: 'L71227_W004', bin: '6', passFailFlag: 'F', binCount: 1,
      }, {
        groupName: 'L71227_W004', bin: '7', passFailFlag: 'F', binCount: 1,
      }, {
        groupName: 'L71227_W004', bin: '22', passFailFlag: 'F', binCount: 3,
      }, {
        groupName: 'L71227_W004', bin: '27', passFailFlag: 'F', binCount: 1,
      }, {
        groupName: 'L71227_W004', bin: '30', passFailFlag: 'F', binCount: 1,
      }, {
        groupName: 'L71227_W004', bin: '35', passFailFlag: 'F', binCount: 1,
      }, {
        groupName: 'L71227_W004', bin: '40', passFailFlag: 'F', binCount: 5,
      }],
    });
  };

  render() {
    const { waferData, dieSubView, dieSize } = this.props;
    // eslint-disable-next-line no-unused-vars
    const { dat, tabDat, wafDat } = this.state;
    const waferDataObj = new WaferData(waferData, dieSubView);
    const dataSource = waferDataObj.dataGenerator();

    return (
      <Container fluid>
        <button type="button" onClick={this.renderHandler}>render</button>
        <Row>
          {/* <Col lg={6}>
            <PlotlyGraph
              hideLegend
              xAxisDataFields={['groupName', 'bin']}
              id={this.appendKeyIndex('plot5')}
              setPlotInstanceHandler={this.setPlotInstanceHandler}
              enableYAxisBreaks
              dataSource={dat}
              isMultiCategory
              type="bar"
              mode="markers"
            />
          </Col>
          <Col lg={6}>
            <CustomizedDataGrid
              showFilterRow
              similarDeletionField="bin"
              selectionMode="multiple"
              publisherId={this.appendKeyIndex('cg5')}
              setCustomGridInstanceHandler={this.setCustomGridInstanceHandler}
              moreOptions={[
                {
                  title: 'Delete Current Item',
                },
                {
                  title: 'Delete Similar Items',
                },
              ]}
              fields={[
                {
                  caption: 'Group Name',
                  dataField: 'groupName',
                  dataType: 'string',
                  showInfo: false,
                  groupIndex: 0,
                },
                {
                  caption: 'Bin',
                  dataField: 'bin',
                  dataType: 'number',
                  colorField: true,
                  showInfo: false,
                },
                {
                  caption: 'Pass Fail',
                  dataField: 'passFailFlag',
                  dataType: 'string',
                  showInfo: false,
                },
                {
                  caption: 'Bin Count',
                  dataField: 'binCount',
                  dataType: 'number',
                  showInfo: false,
                },
              ]}
              // eslint-disable-next-line max-len
              tableData={tabDat}
            />
          </Col> */}
          <Col lg={6}>
            <WaferMap
              // showRadarOnly
              showRotationNotch
              waferTopOffset={20}
              padding={100}
              enableDieImages={false}
              key={new Date().toString()}
              keyIndex={this.appendKeyIndex('wf0')}
              waferData={wafDat}
              enableTooltip
              waferSize={600}
              setWaferInstanceHandler={this.setWaferInstanceHandler}
              dieSize={dieSize}
              hasRotationControls
            />
          </Col>
          <Col lg={6}>
            <WaferMap
              keyIndex={this.appendKeyIndex('wf1')}
              waferData={waferDataObj}
              waferSize={450}
              setWaferInstanceHandler={this.setWaferInstanceHandler}
              dieSize={dieSize}
              hasRotationControls
            />
          </Col>
          <Col lg={6}>
            <CustomizedDataGrid
              showFilterRow
              selectionMode="multiple"
              publisherId={this.appendKeyIndex('cg0')}
              setCustomGridInstanceHandler={this.setCustomGridInstanceHandler}
              fields={[
                {
                  caption: 'Soft Bin',
                  dataField: 'softBin',
                  dataType: 'number',
                  showInfo: false,
                },
              ]}
              tableData={dataSource.dataSource}
            />
          </Col>
          <Col lg={6}>
            <CustomizedDataGrid
              showFilterRow
              selectionMode="multiple"
              publisherId={this.appendKeyIndex('cg1')}
              setCustomGridInstanceHandler={this.setCustomGridInstanceHandler}
              fields={[
                {
                  caption: 'Soft Bin',
                  dataField: 'softBin',
                  dataType: 'number',
                  showInfo: false,
                },
              ]}
              tableData={waferDataObj.dataGenerator().dataSource}
            />
          </Col>
          <Col lg={6}>
            <DataGrid
              keyIndex={this.appendKeyIndex(0)}
              waferData={waferDataObj}
              setGridInstanceHandler={this.setGridInstanceHandler}
            />
          </Col>
          <Col lg={6}>
            <PlotlyGraph
              xAxisDataFields={['dieNumber']}
              id={this.appendKeyIndex('plot0')}
              setPlotInstanceHandler={this.setPlotInstanceHandler}
              dataSource={[{
                x: dataSource.dataSource.map((data: WaferMapData) => data.dieNumber!),
                y: dataSource.dataSource.map((data: WaferMapData) => +data.softBin!),
              }]}
              type="scattergl"
              mode="markers"
            />
          </Col>
          <Col lg={6}>
            <PlotlyGraph
              xAxisDataFields={['dieNumber']}
              id={this.appendKeyIndex('plot1')}
              setPlotInstanceHandler={this.setPlotInstanceHandler}
              dataSource={[{
                x: dataSource.dataSource.map((data: WaferMapData) => data.dieNumber!),
                y: dataSource.dataSource.map((data: WaferMapData) => +data.softBin!),
              }]}
              type="scattergl"
              mode="markers"
            />
          </Col>
        </Row>
      </Container>
    );
  }
}

export default WaferMapGridView;
